import validate from "/codebuild/output/src1997878616/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import slash_45global from "/codebuild/output/src1997878616/src/nuxt/middleware/slash.global.ts";
import manifest_45route_45rule from "/codebuild/output/src1997878616/src/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}